import { apiRequest, HTTP_POST } from 'helpers/http';

const crudCoreServiceRequest = apiRequest(process.env.GATSBY_CRUD_CORE_BASE_URL, false);

export interface ReCaptchaResponse {
  success?: boolean
  challenge_ts?: string
  hostname?: string
  score?: number
  action?: string
}

export const verifyToken = async (
  token: string
): Promise<ReCaptchaResponse> => {
  const response = await crudCoreServiceRequest('api', 'google', 'recaptcha', 'siteverify')(HTTP_POST)()<ReCaptchaResponse>({
    token
  });

  return response.getOrElse({});
};
